var _path, _source;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.8895 5c-2.14811 0-3.8895 1.74139-3.8895 3.8895v14.221c0 2.1481 1.74139 3.8895 3.8895 3.8895h14.221c2.1481 0 3.8895-1.7414 3.8895-3.8895v-14.221c0-2.14811-1.7414-3.8895-3.8895-3.8895zm6.8216 15.9284c-.2426.3769-.5777.5716-.9744.5716-.4006 0-.7241-.1702-1.0245-.5716l-2.9388-3.6505c-.1656-.2312-.2734-.4867-.2734-.7546 0-.5354.4082-.9614.9359-.9614.3274 0 .5893.0974.8782.4868l2.3725 3.1029 4.9955-8.1037c.2272-.3532.5276-.5479.8434-.5479.493 0 .9745.3532.9745.9006 0 .2675-.1464.5354-.2889.7788z",
    fill: "#000",
    fillRule: "evenodd"
  })), _source || (_source = /*#__PURE__*/React.createElement("source", {
    url: "https://altais.com",
    hash: "Tm9ib2R5IGhlcmUgYnV0IHVzIER1Y2tz"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/Checkbox_Selected.2434a430b66890dc07a9d98c9aa7fa40.svg";
export { ForwardRef as ReactComponent };